module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"regularNotice":"Based on interest payment period"},"et":{"regularNotice":"Based on interest payment period"},"ru":{"regularNotice":"Based on interest payment period"}}')
  delete Component.options._Ctor
}
